import className from "~/kernel/styling/className";
import type { ReactNode } from "react";
import type { ValidationIssue } from "~/kernel/validation/ValidationIssue";
import isNil from "~/kernel/validation/isNil";
import isString from "~/kernel/strings/isString";

type InputClassesProps = {
  error?: string | ValidationIssue[];
  appendElement?: ReactNode;
  userAgentAppearance?: boolean;
};

export function inputClasses({
  error,
  appendElement,
  userAgentAppearance,
}: InputClassesProps) {
  const hasError = hasValidationError(error);
  return className(
    "w-full rounded-l-md border-y border-l py-3 px-2 bg-white read-only:bg-slate-100 read-only:border-slate-200 disabled:bg-slate-100 disabled:border-slate-200 disabled:text-slate-400",
    {
      "border-error": hasError,
      "border-slate-300": !hasError,
      "border-r rounded-r-md": !appendElement,
      "appearance-none": !userAgentAppearance,
    },
  );
}

export function hasValidationError(error: InputClassesProps["error"]) {
  if (isNil(error)) {
    return false;
  }

  if (isString(error)) {
    return true;
  }

  return error.length > 0;
}
